module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "sfqldr6j",
    dataset: process.env.GATSBY_SANITY_DATASET || "production"
  }
};
